import _ from 'underscore'
import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'

import '../css/photo-sphere-viewer.css'
window.THREE = require('../lib/three.min.js')
require('../lib/D.min.js')
require('../lib/uevent.min.js')
require('../lib/doT.min.js')
require('../lib/CanvasRenderer.js')
require('../lib/Projector.js')
require('../lib/EffectComposer.js')
require('../lib/CopyShader.js')
require('../lib/RenderPass.js')
require('../lib/ShaderPass.js')
require('../lib/MaskPass.js')
require('../lib/DeviceOrientationControls.js')
const PhotoSphereViewer = require('../lib/photo-sphere-viewer.js')

import locale from '../locale'
import {processBolt} from '../utils/bolt'
import {StyleColors} from '../config'

const MarkerSize = 12
const MarkerColor = {
  Green:'rgba(76,175,80,0.8)',
  Yellow:'rgba(255,193,7,0.8)',
  Red:'rgba(244,67,54,0.8)',
  Gray:'rgba(121,85,72,1)',
  Black:'rgba(121,85,72,1)',
}
const MarkerImage = {
  'Green':'images/green.svg',
  'Yellow':'images/yellow.svg',
  'Red':'images/red.svg',
  'Gray':'images/black.svg',
  'Black':'images/black.svg',
  'Link':'images/link.svg',
}


function CircleMarker({id,x,y,color,number}){
  return {
    id:'circle-'+id,x,y,number,
    circle: MarkerSize,
    svgStyle: {
      fill: color,
    },
    svgStyleText: {
      fill: 'rgba(255, 255, 255, 1)',
      'font-size': '11px',
      'font-weight': 'bold',
      x:'12',
      y:'16',
      'text-anchor':'middle',
    }
  }
}


function ToPSVMarker({id,content,color,longitude,latitude}){
  return {
    id,
    tooltip: {
      content,
      position: 'right bottom',
    },
    image:MarkerImage[color],
    width:MarkerSize,
    height:MarkerSize,

    longitude: longitude,
    latitude: latitude,
    anchor: 'center center'
  }
}


class SphereTopo extends Component {


  getLinkList(links={}){
    return Object.keys(links).filter(id=>!!links[id]).map(id=>{
      let {x,y} = links[id]
      return {
       id,x,y,link:id,
       width: 64,
       height: 64,
       image:'images/link.svg',
     }
   })
  }
  getMarkerList(markers={}){
    return []
    // let {routes} = this.props
    // let list = []
    // Object.keys(markers).forEach(id=>{
    //   let routeId = id
    //   let {name,bolts} = routes[id]
    //   let routeMarkers = markers[id]

    //   Object.keys(markers[id]).forEach(key=>{

    //     let marker = markers[routeId][key]

    //     let {type,year,color,testNote} = processBolt(bolts[key])
    //     let content = `#${id} ${name} ${key}<br/>${type} ${year}`
    //     testNote && (content = content +'<br/>'+testNote)
    //     list.push({
    //      id:id+key,
    //      content,
    //      color,
    //      longitude:markers[id][key][0],
    //      latitude:markers[id][key][1],
    //    })
    //   })
    // })
    // return list
  }

  getLineList(lines={}){
    let {routes} = this.props
    let list = []

    Object.keys(lines).forEach(id=>{
      let number = id
      let points = lines[id]
      if(!points || !points[0])
        return

      let color = routes[id].style.includes('運動') ? StyleColors.Sport : StyleColors.Trad

      list.push({
        number,
        id,
        color,
        line:points,
        svgStyle: {
        fill: 'transparent', //'rgba(255,0,0,0.3)',
        stroke: color,
        'stroke-width': '2px'},
      })

      // let x = points[0][0]
      // let y = points[0][1]
      // list.push(CircleMarker({id,x,y,color,number}))

      // if(points.length>1){
      //   x = points[points.length-1][0]
      //   y = points[points.length-1][1]
      //   id = id+'E'
      //   list.push(CircleMarker({id,x,y,color,number}))
      // }

    })

    return list
  }

  updateMarker(topo,preTopo){

    if(_.isEqual(topo,preTopo))
      return

    let {markers={},lines={},links={},zoom=0} = topo

    this.PSV.clearMarkers()

    this.getLineList(lines).forEach(marker=>{
      this.PSV.addMarker(marker)
    })

    this.getLinkList(links).forEach(marker=>{
      this.PSV.addMarker(marker)
    })

    this.getMarkerList(markers).forEach(marker=>{
      this.PSV.addMarker(ToPSVMarker(marker))
    })

    if(topo.url !== preTopo.url)
      this.PSV.zoom(topo.zoom||30)
    else
      this.PSV.zoom(this.PSV.getZoomLevel())
  }

  componentWillReceiveProps({topo}){
    let preTopo = this.props.topo
    let {url,longitude=0,latitude=0} = topo

    if(url !== preTopo.url){
      this.PSV.clearMarkers()
      this.PSV.setPanorama(url, {longitude,latitude}, true)
      .then(()=>{
        this.updateMarker(topo,preTopo)
      })
    } else {
      this.updateMarker(topo,preTopo)
    }
  }

  componentDidMount() {
    let {area,region,url,markers,lines,longitude,latitude,links,zoom} = this.props.topo
    let markerList = this.getMarkerList(markers)
    let lineList = this.getLineList(lines)
    let linkList = this.getLinkList(links)

    let caption = `${locale.get(area)} · ${locale.get(region)}`
    // let caption = ''
    this.PSV = new PhotoSphereViewer({
      panorama: url,
      container: 'photosphere',
      loading_img: 'images/photosphere-logo.gif',
      navbar: [
      'autorotate',
      'zoom',
      // 'markers',
      'caption',
      'gyroscope',
      'fullscreen'
      ],
      anim_speed: '-2rpm',

      default_lat:latitude||0,
      default_long:longitude||0,
      zoom_lvl:zoom||0,
      max_fov:90,
      default_fov: 90,

      move_speed: 1.1,
      time_anim: false,
      gyroscope: true,
      transition: {
        duration: 1000,
        loader: true,
        blur: true
      },
      markers: [...markerList.map(ToPSVMarker),...lineList,...linkList]
    })

    this.PSV.on('click', (e) =>{
      if(this.props.onClick){
        this.props.onClick(e)
      }
    })

    this.PSV.on('select-marker', (marker) =>{
      // console.log('select-marker',marker)
      if(this.props.onSelect){
        this.props.onSelect(marker.number,marker.link)
      }
    })
    this.PSV.zoom(zoom||0)
  }

  getPosition = ()=>{
    return this.PSV.getPosition()
  }

  getZoomLevel = ()=>{
    return this.PSV.getZoomLevel()
  }

  render() {
    return (
      <div style={this.props.style} id="photosphere" />
      )
  }
}

export default SphereTopo



/** WEBPACK FOOTER **
 ** ./src/app/components/SphereTopo.js
 **/